import React, { Component } from "react";
import axios from "axios";
import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Card, Grid, TextField } from "@mui/material";
import { Navigate } from "react-router-dom";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import MediaPickerModal from "Main/Modals/MediaModal";

export default class AddHomeScreen extends Component {
  state = {
    title: "",
    role_id: "",
    description: "",
    specification: "",
    selectedImage: null,
    showMediaModal: false,

    notification: false,
    message: "",
    redirect: false,
    loading: false,
  };

  // 🔹 Handle inputs
  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  // 🔹 Description textarea
  handleDescription = (e) => {
    this.setState({ description: e.target.value });
  };

  // 🔹 SunEditor
  handleSpecification = (content) => {
    this.setState({ specification: content });
  };

  // 🔹 Submit
  handleSubmit = async (e) => {
    e.preventDefault();

    const {
      title,
      sub_title,
      role_id,
      description,
      specification,
      selectedImage,
    } = this.state;

    if (!selectedImage) {
      return this.setState({
        notification: true,
        message: "Please select an image",
      });
    }

    const payload = {
      title,
      role_id: 1,
      description,
      image_id: selectedImage.id,
    };

    try {
      if (init() === "success") {
        this.setState({ loading: true });

        const resp = await axios.post(Constants.postUrls.createHomeScreen, payload);

        this.setState({
          notification: true,
          message: resp.data.message || "Created successfully!",
          loading: false,
        });

        setTimeout(() => {
          this.setState({ redirect: true });
        }, 2000);
      } else {
        window.location.assign("/signin");
      }
    } catch (err) {
        console.log(err);
        
      this.setState({
        notification: true,
        message: err?.response?.data?.message || "Something went wrong!",
        loading: false,
      });
    }
  };

  render() {
    if (this.state.redirect) {
      return <Navigate to="/homeScreen" />;
    }

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              bgColor="info"
              borderRadius="lg"
            >
              <MDTypography variant="h6" color="white">
                Create Level
              </MDTypography>
            </MDBox>

            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit}>
                <Grid container spacing={2}>
                  {/* Title */}
                  <Grid item sm={6}>
                    <TextField
                      label="Title"
                      name="title"
                      value={this.state.title}
                      onChange={this.handleInput}
                      fullWidth
                    />
                  </Grid>

                  

                  {/* Image Picker */}
                  <Grid item sm={6}>
                    <MDButton
                      variant="contained"
                      color="info"
                      onClick={() => this.setState({ showMediaModal: true })}
                    >
                      Select Image
                    </MDButton>

                    {/* Preview */}
                    {this.state.selectedImage && (
                      <img
                        src={
                          Constants.imageDomain +
                          this.state.selectedImage.image_path
                        }
                        style={{
                          width: 80,
                          height: 80,
                          marginTop: 10,
                          display: "block",
                        }}
                      />
                    )}
                  </Grid>

                  {/* Description (Textarea) */}
                  <Grid item sm={12}>
                    <TextField
                      label="Description"
                      name="description"
                      multiline
                      rows={4}
                      value={this.state.description}
                      onChange={this.handleDescription}
                      fullWidth
                    />
                  </Grid>

                 
                </Grid>

                <Grid mt={2}>
                  <MDButton variant="contained" color="info" type="submit">
                    {this.state.loading ? "Creating..." : "Create"}
                  </MDButton>
                </Grid>
              </form>
            </MDBox>

            {/* Snackbar */}
            <MDSnackbar
              color="success"
              icon="notifications"
              title="Home Screen"
              content={this.state.message}
              open={this.state.notification}
            />

            {/* Media Modal */}
            <MediaPickerModal
              visible={this.state.showMediaModal}
              multiple={false}
              onClose={() => this.setState({ showMediaModal: false })}
              onSelect={(images) => {
                this.setState({
                  selectedImage: images[0],
                  showMediaModal: false,
                });
              }}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
